import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledSubscribeDomainsContent = styled(FlexColumn)`
    justify-content: space-between;
`;

export const StyledSubscribeFileBlock = styled(FlexColumn)`
    justify-content: center;
`;

export const StyledLastUpdatedBlock = styled(Flex)`
    align-items: center;
    ${mixins.setFontVariant("body2", colorsPalettes.carbon[500])}
`;

export const StyledDomainsLimitsBlock = styled(Flex)`
    align-items: center;
    ${mixins.setFontVariant("body2", colorsPalettes.carbon[300])}
`;

export const StyledFileLoaderWrapper = styled(Flex)`
    margin-left: 4px;
`;

export const StyledDomainsLoaderWrapper = styled(Flex)`
    align-items: center;
`;

export const StyledSubscribeFileBlockWrapper = styled(FlexRow)`
    justify-content: space-between;
    margin-top: 16px;
`;

export const StyledDomainLimitUpgradeBannerWrapper = styled(Flex)`
    margin-top: 16px;
`;
